import { Typography, Button, Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import React, { useState } from "react";
import imgExample from '../../img/user-33638_960_720.png'
import './stylesUser.css'
import { ChanguePass } from "./ModalChangePass";
import { Transition } from "../../utils/DialogTitle";
import { EMAIL, ROL_USER, USER_NAME } from "../../app/api-client/constants";

export const UserProfile = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const userEmail = localStorage.getItem(EMAIL);
    const userName = localStorage.getItem(USER_NAME);
    const rol = localStorage.getItem(ROL_USER);

    const formattedRol = rol.split('_')[1];

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start", minHeight: "100vh", marginLeft: "40%", marginTop: "5%" }}>
            <div className="avatar-container">
                <img
                    className="user-profile-img"
                    alt="Contemplative Reptile"
                    height="200"
                    width="200"
                    src={imgExample}
                />
            </div>
            <Typography gutterBottom variant="h5" component="h2">
                <b>{userName}</b>
            </Typography>
            <Typography variant="body1" component="p">
                <b>Email: {userEmail}</b> 
            </Typography>
            <Typography variant="body1" component="p">
                <b>Rol:{formattedRol} </b>
            </Typography>
            <Button variant="contained" color="primary" onClick={openModal}>
                Cambiar Contraseña
            </Button>

     
            <Dialog
                open={isModalOpen} onClose={closeModal}

                aria-labelledby="customized-dialog-title"
                TransitionComponent={Transition}
                keepMounted
                style={{ maxHeight: "500%" }}
                fullWidth={true}
                maxWidth="sm"
            >
                <DialogTitle id="customized-dialog-title" onClose={(e) => { closeModal() }} >
                    {`Cambiar contraseña`}
                </DialogTitle>
                <DialogContent style={{ paddingBottom: '30px' }}>
                    {

                        (<ChanguePass clearData={closeModal} />)
                    }
                </DialogContent>
            </Dialog>
        </div>
    );
};
